@if (open()) {
  <div class="dialog-backdrop" (click)="onBackdropClick()">
    <div class="dialog" [style.max-width]="maxWidth()" (click)="$event.stopPropagation()">
      <div class="dialog-header">
        <h3>{{ title() }}</h3>
        <button type="button" class="close-button" (click)="onCloseClick()" aria-label="Close">
          <icon type="close" />
        </button>
      </div>

      <div class="dialog-body">
        <ng-content select="[dialog-body]" />
      </div>

      <div class="dialog-footer">
        <ng-content select="[dialog-footer]" />
      </div>
    </div>
  </div>
}
